import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import {
  getCompanyServiceProviders,
  postNewCompanyServiceProvider,
  deleteCompanyServiceProvider as deleteCompanyServiceProviderAPI,
} from './api';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CompanyServiceProvider } from './types';

const name = 'serviceProviders';

export const fetchCompanyServiceProviders = createAsyncThunkFromFetch(
  `${name}/fetchCompanyServiceProviders`,
  getCompanyServiceProviders
);

export const createCompanyServiceProvider = createAsyncThunkFromFetch(
  `${name}/createCompanyServiceProvider`,
  postNewCompanyServiceProvider
);

export const deleteCompanyServiceProvider = createAsyncThunkFromFetch(
  `${name}/deleteCompanyServiceProvider`,
  deleteCompanyServiceProviderAPI
);

const serviceProviderAdapter = createEntityAdapter<CompanyServiceProvider>({
  selectId: provider => provider.id,
});

export const serviceProviderSelectors = serviceProviderAdapter.getSelectors();

const serviceProviderSlice = createSlice({
  name,
  initialState: serviceProviderAdapter.getInitialState<{
    companyProviders: CompanyServiceProvider[];
  }>({
    companyProviders: [],
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCompanyServiceProviders.fulfilled, (state, { payload }) => {
      console.log(payload);
      serviceProviderAdapter.setAll(state, payload);
    });
    builder.addCase(createCompanyServiceProvider.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      serviceProviderAdapter.addOne(state, payload);
      state.companyProviders[companyId] = payload.id;
    });
    builder.addCase(deleteCompanyServiceProvider.fulfilled, (state, { meta }) => {
      const { companyId } = meta.arg;
      serviceProviderAdapter.removeOne(state, meta.arg.providerId);
      delete state.companyProviders[companyId];
    });
  },
});

const { reducer } = serviceProviderSlice;

export default reducer;
